import ClampText from "../../../generic components/TextTruncate/TextTruncate";
import classes from "./ProgramReviews.module.scss";

export const ProgramReviews = ({ reviews }) => {
  function parseDate(date) {
    return new Date(date).toLocaleString().split(",")[0].replaceAll("/", "-");
  }

  return (
    <div className={classes.wrapper}>
      {reviews.map((review) => (
        <div className={classes.review}>
          <div className={classes.review__profile}>
            <img src={review.user.image} alt={review.user.fullName} />
            <div className={classes.review__profile__data}>
              <span className={classes.review__profile__data__name}>
                {review.user.fullName}
              </span>
              <span className={classes.review__profile__data__nationality}>
                {review.user.nationality}
              </span>
              <span className={classes.review__profile__data__date}>
                {parseDate(review.createdAt)}
              </span>
            </div>
          </div>
          <div className={classes.review__body}>
            <h2>Review</h2>
            <ClampText text={review.text} lines={3} />
          </div>
        </div>
      ))}
    </div>
  );
};
